import { BackTop } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../assets/Images/icons/icon-back';
import { ROUTER } from '../../constants/router';
import { useCallback, useEffect, useState } from 'react';
import DataFlowService from '../../services/DataFlow.service';
import Tab1 from './components/DataflowDetailView/Tab1';
import Tab2 from './components/DataflowDetailView/Tab2';
import Tab3 from './components/DataflowDetailView/Tab3';
import Tab4 from './components/DataflowDetailView/Tab4';
import Tab7 from './components/DataflowDetailView/Tab7';
import UserService from '../../services/UserService';
import Tab5 from './components/DataflowDetailView/Tab5';
import Tab8 from './components/DataflowDetailView/Tab8';
import Tab6 from './components/DataflowDetailView/Tab6';

export default function DataFlowPreview() {
    const { t } = useTranslation();
    let navigate = useNavigate();
    let { businessProcessId } = useParams();

    const [detail, setDetail] = useState();
    const [personalData, setPersonalData] = useState();
    const [openTabDB, setOpenTabDB] = useState(false);

    const [databaseDetail, setDatabaseDetail] = useState();
    const [loading, setLoading] = useState(false);
    const [metadataList, setMetadataList] = useState([]);
    const [dataFlowInfo, setDataFlowInfo] = useState();

    useEffect(() => {
        if (detail?.collectDataDestruction?.storageLocation) {
            const storageLocation =
                detail?.collectDataDestruction?.storageLocation.find(
                    (m) => m === '42776e1af77c11ec8bf4fa163e89ed46'
                );
            if (storageLocation) {
                setOpenTabDB(true);
            }
        }
    }, [detail]);

    useEffect(() => {
        const newData = {
            categoryPersonalDataId: '',
            personalData: [],
            sensitiveData: [],
            personalDataTopic: [],
        };
        if (detail?.categoryPersonalData) {
            newData.categoryPersonalDataId =
                detail.categoryPersonalData.categoryPersonalDataId;
            if (detail.categoryPersonalData.personalDataAddOn) {
                newData.personalData = [
                    ...detail.categoryPersonalData.personalData,
                ];
                detail.categoryPersonalData.personalDataAddOn.forEach(
                    (element) => {
                        const newElement = {
                            personalDataOptionId:
                                element.personalDataOptionAddOnId,
                            name: element.personalDataOptionAddOnName,
                            metadata: element.metadata,
                        };
                        newData.personalData.push(newElement);
                    }
                );
            }

            if (detail.categoryPersonalData.sensitiveDataAddOn) {
                newData.sensitiveData = [
                    ...detail.categoryPersonalData.sensitiveData,
                ];
                detail.categoryPersonalData.sensitiveDataAddOn.forEach(
                    (element) => {
                        const newElement = {
                            sensitivePersonalDataOptionId:
                                element.sensitivePersonalDataOptionAddOnId,
                            name: element.sensitivePersonalDataOptionAddOnName,
                            metadata: element.metadata,
                        };
                        newData.sensitiveData.push(newElement);
                    }
                );
            }

            if (detail.categoryPersonalData.personalDataTopic) {
                newData.personalDataTopic = [
                    ...detail.categoryPersonalData.personalDataTopic,
                ];
            }
            setPersonalData({ ...newData });
        }
    }, [detail]);

    const getDataFlowDetail = useCallback(async (businessProcessId) => {
        try {
            const { data } = await DataFlowService.getDataFlowDetail(
                businessProcessId
            );
            if (data?.resultData) {
                setDetail(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    }, []);

    const getMetadataList = async () => {
        try {
            const { data } = await DataFlowService.getMetadataList();
            if (data?.resultData) {
                let option = [];
                data?.resultData?.forEach((element) => {
                    option.push({
                        value: element.metadataName,
                        id: element.metadataId,
                    });
                });
                setMetadataList(option);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const getDataBaseDetail = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await DataFlowService.getDataBaseDetail(
                businessProcessId
            );
            if (data?.resultData) {
                setDatabaseDetail(data?.resultData);
            }
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }, [businessProcessId]);

    const getInventoryDataFlowInfo = useCallback(async (businessProcessId) => {
        try {
            const { data } = await DataFlowService.getInventoryDataFlowInfo(
                businessProcessId
            );
            if (data?.resultData) {
                setDataFlowInfo(data.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    }, []);

    useEffect(() => {
        getMetadataList();
        getDataBaseDetail();
        getDataFlowDetail(businessProcessId);
        getInventoryDataFlowInfo(businessProcessId);
    }, [
        businessProcessId,
        getDataBaseDetail,
        getDataFlowDetail,
        getInventoryDataFlowInfo,
    ]);

    const currentPackage = UserService.currentPackage();

    return (
        <div>
            <div className="title flex">
                <button
                    type="button"
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(
                            `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view`
                        );
                    }}
                >
                    <IconBack />
                </button>
                {t('Preview Data Flow')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Inventory')} / {t('Data Flow')} /{' '}
                    {t('Data Flow Details')} /{' '}
                </span>
                <span>{t('Preview Data Flow')}</span>
            </div>
            <div className="mt-4 bg-white rounded-md p-6 overflow-hidden">
                <div className="space-y-4">
                    <div>
                        <span className="text-xl font-semibold">
                            {t('RoPA.DataCollection')}
                        </span>
                        <Tab1
                            collectData={detail?.collectData}
                            editMode={false}
                        />
                    </div>
                    {/* Tab2 */}
                    {personalData && (
                        <div className="grid grid-cols-3">
                            <div className="col-span-2">
                                <Tab2
                                    categoryPersonalData={personalData}
                                    editMode={false}
                                    metadataList={metadataList}
                                    getDataFlowDetail={getDataFlowDetail}
                                    getMetadataList={getMetadataList}
                                />
                            </div>
                        </div>
                    )}
                    {detail?.referenceDocuments?.length > 0 && (
                        <div className="grid grid-cols-3">
                            <div className="col-span-2">
                                <Tab3
                                    referenceDocuments={
                                        detail?.referenceDocuments
                                    }
                                    editMode={false}
                                    metadataList={metadataList}
                                    getDataFlowDetail={getDataFlowDetail}
                                    getMetadataList={getMetadataList}
                                />
                            </div>
                        </div>
                    )}
                    <div>
                        <span className="text-xl font-semibold">
                            {t('RoPA.StorageAndDestruction')}
                        </span>
                        <Tab4
                            collectDataDestruction={
                                detail?.collectDataDestruction
                            }
                            editMode={false}
                        />
                    </div>
                    {openTabDB && currentPackage === 4 && (
                        <div className="grid grid-cols-3">
                            <div className="col-span-2">
                                <span className="text-xl font-semibold">
                                    {t('RoPA.Database')}
                                </span>
                                <Tab7
                                    loading={loading}
                                    databaseInfo={databaseDetail}
                                    editMode={false}
                                    getDataFlowDetail={getDataFlowDetail}
                                />
                            </div>
                        </div>
                    )}
                    <div>
                        <span className="text-xl font-semibold">
                            {t('dataFlow.Remarks')}
                        </span>
                        <Tab5 remarks={detail?.remarks} editMode={false} />
                    </div>
                    <div>
                        <span className="text-xl font-semibold">
                            {t('dcdpo.DataControllerTab')}
                        </span>
                        <Tab8 dcDpo={detail?.dcDpo} editMode={false} />
                    </div>
                    <div className="grid grid-cols-3">
                        <div className="col-span-2">
                            <Tab6
                                isView
                                editMode={false}
                                detail={detail}
                                getDataFlowDetail={getDataFlowDetail}
                                dataFlowInfo={dataFlowInfo}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <BackTop style={{ zIndex: 100000 }}>
                <div
                    className="flex items-center justify-center !bg-[#1890ff]"
                    style={style}
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </div>
    );
}
const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
